import { ColorAll } from '../../themes/default/color/index.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var themeColors = function themeColors() {
  var colorOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var themedColors = _objectSpread({}, ColorAll);

  var keys = Object.keys(colorOverrides);
  keys.forEach(function (colorName) {
    if (colorName && colorName.indexOf('System') !== 0 && colorName.indexOf('Brand') !== 0) {
      var overrideValue = colorOverrides[colorName];

      if (overrideValue && overrideValue[0] === '#' && overrideValue.length === 7) {
        themedColors[colorName] = overrideValue;
      } else if (ColorAll[overrideValue]) {
        themedColors[colorName] = ColorAll[overrideValue];
      } else {
        console.error("Colors override must be a Colors Token name or a six digit hex color code - ignoring ".concat(colorName, " override"));
      }
    } else {
      console.error("User may not override System or Brand Color Tokens - ignoring ".concat(colorName, " override"));
    }
  });
  return themedColors;
};

export { themeColors };
